import { InMemoryCache } from "apollo-cache-inmemory";
import { ApolloClient } from "apollo-client";
import { HttpLink } from "apollo-link-http";

class ApolloClientConfigurator {
  constructor({ uri = "", accessToken = "", headers = {} } = {}) {
    this.uri = uri;
    this.headers = {
      authorization: accessToken ? `Bearer ${accessToken}` : "",
      ...headers
    };
    this.cache = new InMemoryCache();
  }

  Client() {
    return new ApolloClient({
      cache: this.cache,
      link: new HttpLink({ uri: this.uri, headers: this.headers })
    });
  }
}

export default ApolloClientConfigurator;
